/**
 * Custom scrollbar for ingredient cards
 */
class IngredientGridScrollbar extends HTMLElement {
  connectedCallback() {
    this.scrollEl = this.querySelector('[data-ingredient-scroll]');
    this.customScrollbar = this.querySelector('.ingredient-card__custom-scrollbar');
    this.track = this.querySelector('.ingredient-card__scrollbar-track');
    this.thumb = this.querySelector('.ingredient-card__scrollbar-thumb');
    if (!this.scrollEl || !this.customScrollbar || !this.track || !this.thumb) return;

    this.scrollEl.addEventListener('scroll', () => this.update());
    this.thumb.addEventListener('mousedown', (e) => this.startDrag(e));
    this.track.addEventListener('mousedown', (e) => this.trackClick(e));
    window.addEventListener('resize', () => this.update());
    const toggle = this.closest('.ingredient-card')?.querySelector('.ingredient-card__toggle');
    if (toggle)
      toggle.addEventListener('change', () => {
        if (toggle.checked) {
          requestAnimationFrame(() => this.update());
          setTimeout(() => this.update(), 50);
        }
      });
    window.addEventListener('mouseup', () => this.stopDrag());
    window.addEventListener('mousemove', (e) => this.drag(e));

    this.update();
  }

  update() {
    const { scrollHeight, clientHeight, scrollTop } = this.scrollEl;
    const trackH = this.track.offsetHeight;
    const maxScroll = scrollHeight - clientHeight;
    const overflowThreshold = 15;

    if (maxScroll <= overflowThreshold) {
      this.customScrollbar.style.display = 'none';
      return;
    }
    this.customScrollbar.style.display = '';
    this.thumb.style.display = 'block';

    const thumbHeight = Math.max(20, (clientHeight / scrollHeight) * trackH);
    const thumbTop = maxScroll > 0 ? (scrollTop / maxScroll) * (trackH - thumbHeight) : 0;

    this.thumb.style.height = `${thumbHeight}px`;
    this.thumb.style.transform = `translateY(${thumbTop}px)`;
  }

  startDrag(e) {
    e.preventDefault();
    this.dragging = true;
    this.startY = e.clientY;
    this.startScrollTop = this.scrollEl.scrollTop;
  }

  stopDrag() {
    this.dragging = false;
  }

  drag(e) {
    if (!this.dragging) return;
    const trackH = this.track.offsetHeight;
    const thumbH = this.thumb.offsetHeight;
    const maxScroll = this.scrollEl.scrollHeight - this.scrollEl.clientHeight;
    const maxThumbMove = trackH - thumbH;
    const dy = e.clientY - this.startY;
    const scrollDelta = maxScroll > 0 && maxThumbMove > 0 ? (dy / maxThumbMove) * maxScroll : 0;
    this.scrollEl.scrollTop = Math.max(0, Math.min(maxScroll, this.startScrollTop + scrollDelta));
    this.startY = e.clientY;
    this.startScrollTop = this.scrollEl.scrollTop;
  }

  trackClick(e) {
    if (e.target === this.thumb) return;
    const rect = this.track.getBoundingClientRect();
    const trackH = this.track.offsetHeight;
    const thumbH = this.thumb.offsetHeight;
    const maxScroll = this.scrollEl.scrollHeight - this.scrollEl.clientHeight;
    const maxThumbMove = trackH - thumbH;
    const clickY = e.clientY - rect.top;
    const thumbCenter = thumbH / 2;
    const thumbTop = Math.max(0, Math.min(maxThumbMove, clickY - thumbCenter));
    const scrollTop = maxThumbMove > 0 ? (thumbTop / maxThumbMove) * maxScroll : 0;
    this.scrollEl.scrollTo({ top: scrollTop, behavior: 'smooth' });
  }
}

customElements.define('ingredient-scrollbar', IngredientGridScrollbar);

function initIngredientScrollbars() {
  document.querySelectorAll('.ingredient-card__scroll-wrap:not(:has(ingredient-scrollbar))').forEach((wrap) => {
    const el = document.createElement('ingredient-scrollbar');
    el.append(...wrap.children);
    wrap.appendChild(el);
  });
}

document.addEventListener('DOMContentLoaded', initIngredientScrollbars);
document.addEventListener('shopify:section:load', initIngredientScrollbars);
